export default __webpack_public_path__ + "static/media/file_thumbnail.f1a98b11.svg";